import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { environment } from '../../environments/environment'
import { ArticleTemplate } from '../_models'

@Injectable({
  providedIn: 'root'
})
export class ArticleTemplateService {

  constructor(
    private http: HttpClient,
  ) {
  }

  public all(params: any = {}) {
    const path = environment.apiURL + 'article_templates.json'

    return this.http.get<ArticleTemplate[]>(path, { params: params })
  }

  public update(id: string | string | number, params: any) {
    const path = environment.apiURL + 'article_templates/'+ id +'.json'
    return this.http.patch<ArticleTemplate>(path, params)
  }

  public create(params: any) {
    const path = environment.apiURL + 'article_templates.json'
    return this.http.post<ArticleTemplate>(path, params)
  }

  public delete(id: string | string | number) {
    const path = environment.apiURL + 'article_templates/'+ id +'.json'
    return this.http.delete<any>(path)
  }

  public getArticleTemplate(id: number | string | string) {
    const path = environment.apiURL + 'article_templates/' + id + '.json'

    return this.http.get<ArticleTemplate>(path)
  }

  /** Lädt ein Artikelbild als Multipart-Upload hoch und liefert den generierten Dateinamen */
  public uploadImage(id: number | string, image: File) {
    const path = environment.apiURL + 'article_templates/' + id + '/upload_image.json'
    const formData = new FormData()
    formData.append('image', image)

    return this.http.post<{ success: boolean; filename: string }>(path, formData)
  }

  /** Entfernt das Artikelbild der Vorlage */
  public deleteImage(id: number | string) {
    const path = environment.apiURL + 'article_templates/' + id + '/image.json'

    return this.http.delete<{ success: boolean }>(path)
  }

  /** URL zum Ausliefern des Artikelbilds (ohne .json, direkt als img-src nutzbar) */
  public getImageUrl(id: number | string, filename: string) {
    return environment.apiURL + 'article_templates/' + id + '/image/' + filename
  }
}
